import { render, staticRenderFns } from "./mpModule5.vue?vue&type=template&id=27435051&scoped=true"
import script from "./mpModule5.vue?vue&type=script&lang=js"
export * from "./mpModule5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27435051",
  null
  
)

export default component.exports